<template>
  <a-config-provider
    :theme="{
      algorithm: theme.defaultAlgorithm,
      token: {
        colorPrimary: 'black',
      },
    }"
  >
    <div class="flex min-h-screen flex-col bg-slate-200">
      <div class="flex grow flex-col items-center justify-center">
        <div class="w-5/6 max-w-6xl flex-col rounded-xl bg-white shadow-lg lg:max-w-3xl">
          <div class="px-6 py-8 sm:px-10 md:px-12 lg:px-16">
            <div class="flex size-full flex-col justify-center pb-8 pt-4">
              <router-view />
            </div>
          </div>
        </div>

        <div
          v-if="props.showBackButton"
          class="flex w-5/6 max-w-6xl flex-row lg:max-w-3xl"
        >
          <button
            onclick="history.back()"
            class="m-2 mb-6 bg-transparent font-medium text-slate-600 hover:text-slate-800"
          >
            <small>Go Back</small>
          </button>
        </div>
      </div>
    </div>
  </a-config-provider>
</template>
<script setup lang="ts">
import { theme } from 'ant-design-vue';

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: false,
  },
});
</script>
